// auth
export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGOUT_USER = 'LOGOUT_USER';

// data
export const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE';

export const FETCH_BOOKS_DATA_REQUEST = 'FETCH_BOOKS_DATA_REQUEST';
export const RECEIVE_BOOKS_DATA = 'RECEIVE_BOOKS_DATA';
export const FETCH_BOOKS_DATA_FAILURE = 'FETCH_BOOKS_DATA_FAILURE';

export const FETCH_BOOK_DATA_REQUEST = 'FETCH_BOOK_DATA_REQUEST';
export const RECEIVE_BOOK_DATA = 'RECEIVE_BOOK_DATA';
export const SET_BOOK_DATA = 'SET_BOOK_DATA';
export const SET_CURRENT_BOOK_KEY= 'SET_CURRENT_BOOK_KEY';
export const FETCH_BOOK_DATA_FAILURE = 'FETCH_BOOK_DATA_FAILURE';

export const FETCH_ARTICLE_DATA_REQUEST = 'FETCH_ARTICLE_DATA_REQUEST';
export const RECEIVE_ARTICLE_DATA = 'RECEIVE_ARTICLE_DATA';
export const SET_ARTICLE_DATA = 'SET_ARTICLE_DATA';
export const SET_CURRENT_ARTICLE_KEY= 'SET_CURRENT_ARTICLE_KEY';
export const FETCH_ARTICLE_DATA_FAILURE = 'FETCH_ARTICLE_DATA_FAILURE';

// ctrl
export const SET_DRAWER_CONTAINER_SCROLL_PARAMS = 'SET_DRAWER_CONTAINER_SCROLL_PARAMS';


// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js